class MemoController {
  constructor(Word, GameResult, $interval, ipCookie) {
    'ngInject';
    Object.assign(this, {
      Word,
      GameResult,
      $interval,
      ipCookie,
    });
    this.words = [];
    this.wordsLoading = false;

    this.currentLevel = 0;
    this.levels = [
      [2, 2],
      [2, 3],
      [2, 4],
      [2, 5],
      [3, 4],
      [4, 4],
      [4, 5],
    ];

    this.rows = this.levels[this.currentLevel][0];
    this.cols = this.levels[this.currentLevel][1];

    this.timer = 0;
    this.timerPromise = null;
    this.startGame = false;
    this.gameOver = false;
    this.words = [];
    this.learn = [];
    this.visibleCards = [];
    this.tempVisibleCards = [];
    this.correctCards = [];
    this.showStartGameButton = false;
    this.isResultSaved = false;

    this.loadWords();
  }

  loadWords() {
    this.showStartGameButton = false;
    this.words = [];
    this.learn = [];
    this.wordsLoading = true;
    this.Word.get({ rows: this.rows, cols: this.cols }).$promise.then(words => {
      this.words = words.words;
      this.learn = words.learn;
      this.showStartGameButton = true;
    })
    .finally(() => {
      this.wordsLoading = false;
    });
  }


  restartGame() {
    this.timer = 0;
    this.timerPromise = null;
    this.startGame = false;
    this.gameOver = false;
    this.visibleCards = [];
    this.tempVisibleCards = [];
    this.correctCards = [];
    this.currentLevel = 0;
    this.isResultSaved = false;
    this.rows = this.levels[this.currentLevel][0];
    this.cols = this.levels[this.currentLevel][1];

    this.loadWords();
  }


  nextLevel() {
    this.currentLevel += 1;
    if (this.currentLevel > this.levels.length) {
      return;
    }
    this.rows = this.levels[this.currentLevel][0];
    this.cols = this.levels[this.currentLevel][1];
    this.timerPromise = null;
    this.startGame = false;
    this.gameOver = false;
    this.visibleCards = [];
    this.tempVisibleCards = [];
    this.correctCards = [];
    this.loadWords();
  }


  start() {
    this.startGame = true;
    this.startCounting();
  }


  startCounting() {
    this.timerPromise = this.$interval(() => {
      this.timer += 1;
    }, 10);
  }


  stopCounting() {
    this.$interval.cancel(this.timerPromise);
  }


  checkIfVisible(index1, index2) {
    return this.visibleCards.filter(
        item => item[0]===index1 && item[1]===index2
    ).length;
  }


  checkIfCorrect(index1, index2) {
    return this.correctCards.filter(
      item => item[0]===index1 && item[1]===index2
    ).length;
  }


  checkIfEnd() {
    if (this.correctCards.length === (this.rows*this.cols)) {
      this.stopCounting();
      this.gameOver = true;
      this.startGame = false;
    }
  }


  showCard(index1, index2) {
    if (this.canBeShow(index1, index2)) {
      if (this.tempVisibleCards.length === 2) {
        this.resetTempVisibleCards();
      }
      this.tempVisibleCards.push([index1, index2]);
      this.visibleCards.push([index1, index2]);
      if (this.tempVisibleCards.length === 2) {
        this.checkTempVisibleCardsAreCorrect();
        this.checkIfEnd();
      }
    }
  }


  canBeShow(index1, index2) {
    return !this.checkIfCorrect(index1, index2);
  }


  checkTempVisibleCardsAreCorrect() {
    var index1_1 = this.tempVisibleCards[0][0];
    var index1_2 = this.tempVisibleCards[0][1];
    var index2_1 = this.tempVisibleCards[1][0];
    var index2_2 = this.tempVisibleCards[1][1];
    if (this.words[index1_1][index1_2].correct === this.words[index2_1][index2_2].correct) {
      this.tempVisibleCards.forEach(item => {
        this.correctCards.push(item);
      });
      this.resetTempVisibleCards();
    }
  }


  resetTempVisibleCards() {
    this.visibleCards = this.visibleCards.filter(
        item => !this.tempVisibleCards.filter(
          tmp => item[0]===tmp[0] && item[1]===tmp[1]
        ).length
    );
    this.tempVisibleCards = [];
  }


  saveResult() {
    const gameResult = new this.GameResult();
    gameResult.$save({ time: this.timer * 10 })
      .then(response => {
        if (response) {
          if (response.hash) {
            this.ipCookie('jezor_game_result_hash', response.hash, {
              path: '/'
            });
          }
        }

        if (!response.logged) {
          document.location.href = webroot + 'logowanie';
        } else {
          this.isResultSaved = true;
        }
      });
  }


  play(id) {
    document.getElementById('player_' + id).play();
  }
}

export default MemoController;


// WEBPACK FOOTER //
// ./client/app/components/memo/memo.controller.js